import { useQuery } from "@tanstack/react-query";
import { defaultOnError } from "util/conditional/onError";
import useTableFilterContext from "components/common/PaginatedEntityTable/useTableFilterContext";
import { slicesQueryKey } from "components/common/PaginatedEntityTable/slicing/queryKeys";
import useOnRefresh from "components/common/PaginatedEntityTable/useOnRefresh";
const useFetchSlices = (fetchSlices, sliceRenderers) => {
  const {
    searchParams: { sliceCol, query, filters }
  } = useTableFilterContext();
  const { data, isLoading, refetch } = useQuery({
    queryKey: slicesQueryKey(sliceCol, query, filters),
    queryFn: () => defaultOnError(
      fetchSlices(sliceCol, query, filters).then(
        ({ slices }) => {
          var _a, _b, _c;
          return (_c = (_b = (_a = sliceRenderers == null ? void 0 : sliceRenderers[sliceCol]) == null ? void 0 : _a.extendSlices) == null ? void 0 : _b.call(_a, slices)) != null ? _c : slices;
        }
      ),
      "Error fetching table slices"
    )
  });
  useOnRefresh(refetch);
  return { slices: data != null ? data : [], isLoading, refetchSlices: refetch };
};
export default useFetchSlices;
